import React from 'react';
import { TableColumnProps } from './table-column-props';
import { cx } from '@mint/core';
import styled from 'styled-components';
import { useTableState } from '../table';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'table-column';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'div';

/**
 * List component implementation before styling.
 */
export const TableColumnComponent = React.forwardRef<any, TableColumnProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      name,
      style: styleProp,
      ...rest
    } = props;

    const tableState = useTableState();
    const columnWidth = name ? tableState.columnWidths[name] : undefined;

    const style = {
      width: columnWidth,
      flex: columnWidth ? 'none' : undefined,
      ...styleProp,
    };

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      style,
      ref,
    };

    return <Component {...componentProps}>{children}</Component>;
  },
);

TableColumnComponent.displayName = 'TableColumn';

export const TableColumn = styled(TableColumnComponent)`
  display: flex;
  flex: 1;
  padding: 0.5rem;
`;
